import request from "@/utils/request";

export function saveAppSuggestFeeback(data){
    return request.post('/api/appSuggest/savebyUserId', data);
}